module.exports = __webpack_public_path__ + "static/media/6.d705d4b8.jpg";